<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-0 transparent">
          <v-card-title class="px-0">
            <span class="text-subtitle-1">Reporte Twilio RH por vacante</span>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              small
              tile
              to="/twilio-rh"
            >
              <v-icon left small>mdi-whatsapp</v-icon>
              Inbox
            </v-btn>
            <v-btn
              class="mr-2"
              small
              dark
              color="green"
              tile
              :disabled="!vacantes.length"
              @click="exportExcel(filasExcel, 'reporte-twilio-rh')"
            >
              <v-icon left small>mdi-microsoft-excel</v-icon>
              Excel
            </v-btn>
            <v-btn
              color="primary"
              dark
              small
              tile
              @click="cargar"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card class="shadowCard pa-4">
            <v-row dense align="center">
              <v-col cols="6" sm="3" md="2">
                <v-select
                  v-model="mes"
                  :items="itemsMes"
                  label="Mes"
                  filled
                  dense
                  hide-details
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="3" md="2">
                <v-select
                  v-model="anio"
                  :items="itemsAnio"
                  label="Año"
                  filled
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" class="text-caption grey--text">
                Solo postulantes que llegaron por WhatsApp. Contratado = Aceptado y Descartado = Rechazado, igual que en Prospectos RH. Papelera no entra.
              </v-col>
            </v-row>

            <v-row class="mt-2" dense>
              <v-col cols="6" sm="3">
                <div class="text-caption grey--text">Aplicaron</div>
                <div class="text-h6">{{ totales.aplicaron }}</div>
              </v-col>
              <v-col cols="6" sm="3">
                <div class="text-caption grey--text">En proceso</div>
                <div class="text-h6">{{ totales.en_proceso }}</div>
              </v-col>
              <v-col cols="6" sm="3">
                <div class="text-caption grey--text">Contratados</div>
                <div class="text-h6 teal--text">{{ totales.contratados }}</div>
              </v-col>
              <v-col cols="6" sm="3">
                <div class="text-caption grey--text">Descartados</div>
                <div class="text-h6">{{ totales.descartados }}</div>
              </v-col>
            </v-row>

            <v-data-table
              class="mt-4 elevation-0"
              dense
              :headers="headers"
              :items="vacantes"
              :loading="cargarTabla"
              item-key="idpuesto"
              no-data-text="No hay postulantes de WhatsApp en ese mes."
            >
            </v-data-table>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'

const ITEMS_MES = [
  { value: 1, text: 'Enero' },
  { value: 2, text: 'Febrero' },
  { value: 3, text: 'Marzo' },
  { value: 4, text: 'Abril' },
  { value: 5, text: 'Mayo' },
  { value: 6, text: 'Junio' },
  { value: 7, text: 'Julio' },
  { value: 8, text: 'Agosto' },
  { value: 9, text: 'Septiembre' },
  { value: 10, text: 'Octubre' },
  { value: 11, text: 'Noviembre' },
  { value: 12, text: 'Diciembre' },
]

export default {
  name: 'TwilioRhReporte',
  mixins: [validarErrores, funcionesExcel],
  components: { Alerta, carga },
  data: () => {
    const d = new Date()
    return {
      anio: d.getFullYear(),
      mes: d.getMonth() + 1,
      itemsMes: ITEMS_MES,
      vacantes: [],
      totales: { aplicaron: 0, en_proceso: 0, contratados: 0, descartados: 0 },
      cargarTabla: false,
      headers: [
        { text: 'Vacante', value: 'puesto' },
        { text: 'Aplicaron', value: 'aplicaron', align: 'end' },
        { text: 'En proceso', value: 'en_proceso', align: 'end' },
        { text: 'Contratados', value: 'contratados', align: 'end' },
        { text: 'Descartados', value: 'descartados', align: 'end' },
      ],
    }
  },
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    itemsAnio () {
      const y = new Date().getFullYear()
      return [y, y - 1, y - 2]
    },
    filasExcel () {
      return (this.vacantes || []).map((r) => ({
        Vacante: r.puesto,
        Aplicaron: r.aplicaron,
        'En proceso': r.en_proceso,
        Contratados: r.contratados,
        Descartados: r.descartados,
      }))
    },
  },
  watch: {
    mes () {
      this.cargar()
    },
    anio () {
      this.cargar()
    },
  },
  created () {
    this.cargar()
  },
  methods: {
    cargar () {
      const anio = Number(this.anio)
      const mes = Number(this.mes)
      if (!anio || !mes) return
      this.cargarTabla = true
      return this.$http.post('twilio-rh.reporte', { anio, mes }).then((response) => {
        const data = response.data || {}
        this.vacantes = data.vacantes || []
        this.totales = data.totales || { aplicaron: 0, en_proceso: 0, contratados: 0, descartados: 0 }
      }).catch((error) => {
        this.vacantes = []
        this.totales = { aplicaron: 0, en_proceso: 0, contratados: 0, descartados: 0 }
        this.validarError(error)
      }).finally(() => {
        this.cargarTabla = false
      })
    },
  },
}
</script>
